module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-41.a594eb9f.jpg";